<template>
  <div :class="{'kn-rbac': useDesignV2}">
    <aside v-if="useDesignV2" class="kn-rbac__groups">
      <div class="kn-rbac__groups-title"><i class="fas fa-shield-alt"></i> Разделы</div>
      <button
        type="button"
        class="kn-rbac__group"
        :class="{'is-active': !activeGroup}"
        @click="activeGroup = null"
      >
        <span>Все разрешения</span>
        <span class="kn-rbac__group-count">{{ permissions.length }}</span>
      </button>
      <button
        v-for="group in groupedPermissions"
        :key="group.name"
        type="button"
        class="kn-rbac__group"
        :class="{'is-active': activeGroup === group.name}"
        @click="activeGroup = group.name"
      >
        <span>{{ group.description }}</span>
        <span class="kn-rbac__group-count">{{ group.children.length }}</span>
      </button>
    </aside>

    <div :class="{'kn-rbac__matrix': useDesignV2}">
    <div v-if="useDesignV2" class="kn-rbac__toolbar">
      <el-input
        v-model="permissionsSearch"
        class="kn-rbac__search"
        placeholder="Поиск по разрешениям"
        clearable
        prefix-icon="el-icon-search"
      ></el-input>
      <el-button
        v-if="$canAndRulesPass(user, $permissions.RBAC.ROLE_CREATE)"
        type="primary"
        icon="fas fa-plus"
        @click="manageEditModalShow({})"
      >
        Создать роль
      </el-button>
    </div>

    <el-table
      ref="rbacTable"
      :key="tableKey"
      :data="filteredPermissions"
      :border="!useDesignV2"
      style="width: 100%"
      :height="useDesignV2 ? 'calc(100vh - 250px)' : '78vh'"
      v-loading="loading"
      row-key="name"
    >
<!--      default-expand-all-->
      <el-table-column fixed prop="description" label="Название" min-width="300">
        <template slot="header"  slot-scope="scope">
          <div v-if="useDesignV2">Разрешение</div>
          <div v-else align="center">
            <div class="el-row--flex">
              <el-input
                v-model="permissionsSearch"
                placeholder="Фильтр по названию полномочия"
                size="medium"
                clearable
                prefix-icon="el-icon-search"
              ></el-input>
              <el-button
                v-if="$canAndRulesPass(user, $permissions.RBAC.ROLE_CREATE)"
                style="margin-left: 20px"
                type="primary"
                @click="manageEditModalShow({})"
                size="mini"
                icon="fas fa-plus"
              >
                Создать роль
              </el-button>
            </div>
          </div>
        </template>
        <template v-slot="scope">
          <span :class="{'kn-rbac__group-row': useDesignV2 && scope.row.children}">{{ scope.row.description }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        v-for="role in roles"
        min-width="140"
        :key="role.id"
      >
        <template v-slot:header>
          <div align="center">
            <div>
              {{ role.description }}
              <el-button
                v-if="$canAndRulesPass(user, $permissions.RBAC.ROLE_UPDATE)"
                class="table-action-button"
                style="margin-left: 5px"
                size="mini"
                round
                icon="fas fa-pen"
                @click="manageEditModalShow(role)"
              >
              </el-button>
            </div>
            <div>
              <el-button
                v-if="$canAndRulesPass(user, $permissions.RBAC.MANAGE_USERS)"
                style="margin-top: 5px"
                type="primary"
                plain
                size="mini"
                icon="far fa-user"
                @click="manageUsersModalShow(role)"
              >
                Управление
              </el-button>
            </div>
          </div>
        </template>
        <template v-slot="scope">
          <div style="position: relative;">
            <toggle-switch
              v-if="scope.row.roles && useDesignV2"
              v-model="scope.row.roles[role.name]"
              :disabled="!$canAndRulesPass(user, $permissions.RBAC.SET_PERMISSION)"
              :label="role.description + ': ' + scope.row.description"
              @change="permissionChanged(scope.row, role)"
            ></toggle-switch>
            <el-switch
              v-else-if="scope.row.roles"
              :disabled="!$canAndRulesPass(user, $permissions.RBAC.SET_PERMISSION)"
              v-model="scope.row.roles[role.name]"
              @change="permissionChanged(scope.row, role)"
            >
            </el-switch>
              <el-button
                v-if="scope.row.roles"
                :class="{'kn-rbac__history': useDesignV2}"
                style="position: absolute; top:0; right:0;opacity: 0.3; color: gray"
                type="text"
                size="mini"
                icon="fas fa-history"
                @click="manageHistoryModalShow(role.name, scope.row.name)"
              >
              </el-button>
          </div>

        </template>
      </el-table-column>
    </el-table>
    </div>

    <history-modal
      ref="historyModalDialog"
      title="История изменений"
      width="50%"
      hide-type-full-name
      hide-field-full-name
      :method="$api.rbac.getHistory"
    >
    </history-modal>


    <rbac-role-users-dialog
      ref="roleUsersDialog"
    ></rbac-role-users-dialog>

    <rbac-role-edit-dialog
      ref="roleEditDialog"
      @role-updated="getPermissionsWithRoles"
    ></rbac-role-edit-dialog>

  </div>
</template>

<script>

import RbacRoleUsersDialog from "@/components/settings/rbac/RbacRoleUsersDialog";
import RbacRoleEditDialog from "@/components/settings/rbac/RbacRoleEditDialog";
import {mapGetters} from "vuex";
import HistoryModal from "@/components/HistoryModal.vue";
import ToggleSwitch from "@/components/designV2/ToggleSwitch.vue";

export default {
  name: 'rbac-table',
  components: {ToggleSwitch, HistoryModal, RbacRoleEditDialog, RbacRoleUsersDialog},

  data() {
    return {
      loading: false,

      roles: [],
      permissions: [],

      permissionsSearch: '',
      activeGroup: null,
      tableKey: 1,
    }
  },
  computed: {
    ...mapGetters(['user']),
    ...mapGetters('settings', ['useDesignV2']),
    filteredPermissions() {
      const group = this.activeGroup
        ? this.groupedPermissions.find(g => g.name === this.activeGroup)
        : null;

      if (!this.permissionsSearch) {
        return group ? group.children : this.groupedPermissions;
      }

      const source = group ? group.children : this.permissions;
      return source.filter(permission => {
        return permission.description.toLowerCase().indexOf(this.permissionsSearch.toLowerCase()) > -1
      })
    },

    groupedPermissions() {
      let groups = {};
      this.permissions.forEach(permission => {
        const permissionGroup = permission.description.split('.')[0];
        if (!groups[permissionGroup]) {
          groups[permissionGroup] = [];
        }
        groups[permissionGroup].push(permission);
      });

      let groupedPermissions = [];
      for (const [key, value] of Object.entries(groups)) {
        groupedPermissions.push({
          name: key,
          description: value[0].description.split('.')[0], // Берем имя из первого пермишена до точки
          children: value,
        })
      }
      return groupedPermissions;
    }
  },

  mounted() {
    this.getPermissionsWithRoles();
  },
  methods: {
    getPermissionsWithRoles() {
      this.roles = [];
      this.permissions = [];

      this.loading = true;
      this.$api.rbac.getPermissionsWithRoles()
        .then(data => {
          this.permissions = data.permissions;
          this.roles = data.roles;
          this.$nextTick(() => {
            this.tableKey++;
          });
        })
        .finally(() => {
          this.loading = false;
        })
    },

    permissionChanged(permission, role) {
      this.loading = true;
      this.$api.rbac.setRolePermission({
        role_name: role.name,
        permission_name: permission.name,
        value: permission.roles[role.name],
      })
        .then(data => {
          this.$notify.success({
            title: 'Сохранено',
            message: 'Правило успешно сохранено'
          });
        })
        .finally(() => {
          this.loading = false;
        })
    },


    manageUsersModalShow(role) {
      this.$refs.roleUsersDialog.open(role);
    },
    manageEditModalShow(role) {
      this.$refs.roleEditDialog.open(role);
    },

    manageHistoryModalShow(role_name, permission_name){
      this.$refs.historyModalDialog.showHistory(null, {  role_name: role_name, permission_name: permission_name });
    },


  }
}

</script>

<style lang="scss">
.kn-rbac {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  gap: 20px;
  align-items: start;

  &__groups {
    position: sticky;
    top: calc(var(--kn-topbar-height) + 16px);
    max-height: calc(100vh - 200px);
    overflow-y: auto;
    padding: 12px;
    border: 1px solid var(--kn-border);
    border-radius: var(--kn-radius-card);
    background-color: var(--kn-card-muted);
  }

  &__groups-title {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 8px 12px;
    color: var(--kn-primary);
    font-weight: 700;
  }

  &__group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    padding: 9px 10px;
    margin-bottom: 2px;
    border: 0;
    border-radius: 10px;
    background: transparent;
    color: var(--kn-text);
    font-family: inherit;
    font-size: 13px;
    text-align: left;
    cursor: pointer;

    &:hover { background-color: var(--kn-hover); }

    &.is-active {
      background-color: var(--kn-primary-soft);
      color: var(--kn-primary);
      font-weight: 600;
    }
  }

  &__group-count {
    min-width: 24px;
    padding: 1px 8px;
    border-radius: var(--kn-radius-pill);
    background-color: var(--kn-card);
    color: var(--kn-text-muted);
    font-size: 11px;
    font-weight: 600;
    text-align: center;
  }

  &__toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;
  }

  &__search {
    max-width: 360px;
  }

  &__group-row {
    font-weight: 700;
  }

  &__history {
    top: 1px !important;
  }

  .el-table th.el-table__cell .cell {
    color: var(--kn-text);
    font-size: 13px;
  }
}

@media (max-width: 1023px) {
  .kn-rbac {
    grid-template-columns: 1fr;

    &__groups {
      position: static;
      display: flex;
      gap: 6px;
      overflow-x: auto;
      max-height: none;
    }

    &__groups-title { display: none; }

    &__group {
      width: auto;
      white-space: nowrap;
    }
  }
}
</style>